export const getCountry = (state) => state.app.country
export const getClientType = (state) => state.app.clientType || 'direct'
export const getUserToken = (state) => state.app.userToken
export const getWebviewStatus = (state) => {
  const {
    app: { clientType }
  } = state

  return clientType === 'ios' || clientType === 'android'
}
